import Swiper from 'swiper/bundle'
import 'swiper/css/bundle'

export class CsrSlider {
  constructor() {
    document.addEventListener('DOMContentLoaded', () => {
      const sliders01 = document.querySelectorAll('.js-csr_slider')
      sliders01.forEach((elm) => {
        const swiper01 = new Swiper(elm, {
          slidesPerView: 1,
          loop: true,
          autoplay: {
            delay: 2000,
          },
          pagination: {
            el: '.swiper-pagination',
          },
        })
      })
    })
  }
}
